<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  name: "app",
  mounted() {
    this.config().then(
      (data) => {
        document.title = data.title;
        let kw = document.querySelector("meta[name='keywords']"),
          des = document.querySelector("meta[name='description']");
        kw.content = data.keys;
        des.content = data.descp;
        kw = des = null;
      },
      (error) => {
        throw new Error(error);
      }
    );
    let uid = this.$getCookie('cy_uid');
    if (uid) {
      this.getUser({uid});
    }
  },
  methods: {
    ...mapActions(["config","getUser"]),
  },
};
</script>

<style lang="less">
@import "./assets/css/reset.css";
@import "./assets/css/flex.css";
@import "./assets/css/layout.css";
@import "./assets/css/font.css";
@import "~swiper/dist/css/swiper.css";
.cursor{
  cursor: pointer;
  &:hover{text-decoration: underline;}
}
.pagination .el-pagination.is-background .el-pager li:not(.disabled).active{
    background: rgba(173, 39, 41, 1);
}
.pagination .el-pagination.is-background .el-pager li:not(.active):hover{
     color: rgba(173, 39, 41, 1);
 }
.mainBanner {
  width: 1184px;
  height: 136px;
  margin-top: 40px;
  position: relative;
  background: rgba(0, 0, 0, 0.2);
  img {
    width: 100%;
    height: 100%;
  }
  p {
    height: 24px;
    font-size: 16px;
    line-height: 24px;
    padding: 0 6px;
    color: white;
    position: absolute;
    right: 12px;
    top: 12px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
}
</style>
